
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { createForOfIteratorHelper as _createForOfIteratorHelper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import '../../../node_modules/core-js/modules/es.array.iterator.js';
import '../../../node_modules/core-js/modules/es.array.map.js';
import '../../../node_modules/core-js/modules/es.object.from-entries.js';

var DEFAULT_TYPESCALE_CONFIG = {
  baseFontSize: 1,
  // rem
  lineHeight: 1.5715,
  sizeRatio: 1.125,
  // major second
  levels: {
    down: ["sm", "xs", "2xs"],
    base: "md",
    up: ["lg", "xl", "2xl", "3xl", "4xl"]
  }
};
var ROOT_FONT_SIZE_PX = 16; // typical browser default
var orderedKeys = ["2xs", "xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl"];
var generateTypeScaleSizes = function generateTypeScaleSizes(typography) {
  var rootFontSizePx = ROOT_FONT_SIZE_PX;
  var baseRem = typography.baseFontSize;
  var basePx = baseRem * rootFontSizePx;
  var currentPx = basePx;
  var levels = {
    "2xs": 0,
    xs: 0,
    sm: 0,
    md: baseRem,
    lg: 0,
    xl: 0,
    "2xl": 0,
    "3xl": 0,
    "4xl": 0
  };
  var _iterator = _createForOfIteratorHelper(typography.levels.up),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var level = _step.value;
      currentPx *= typography.sizeRatio; // increase size by ratio
      var roundedPx = Math.round(currentPx); // round to whole px for consistency
      levels[level] = roundedPx / rootFontSizePx; // convert back to rem and store
      currentPx = roundedPx; // carry forward rounded px
    }

    // Reset to base for computing smaller sizes
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  currentPx = basePx;
  var _iterator2 = _createForOfIteratorHelper(typography.levels.down),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _level = _step2.value;
      currentPx /= typography.sizeRatio;
      var _roundedPx = Math.round(currentPx);
      levels[_level] = _roundedPx / rootFontSizePx;
      currentPx = _roundedPx;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var orderedLevels = Object.fromEntries(orderedKeys.map(function (key) {
    return [key, levels[key]];
  }));

  // Return via proxy (string with "rem" suffix)
  return new Proxy(orderedLevels, {
    get: function get(target, prop) {
      return typeof prop === "string" && prop in target ? "".concat(target[prop], "rem") : undefined;
    }
  });
};

// Generate the type scale sizes based on the default configuration.
var typeScale = generateTypeScaleSizes(DEFAULT_TYPESCALE_CONFIG);

export { DEFAULT_TYPESCALE_CONFIG, generateTypeScaleSizes, typeScale };
//# sourceMappingURL=typography.js.map
